import { render, staticRenderFns } from "./DialogContactDetails.vue?vue&type=template&id=2c9d905e&"
import script from "./DialogContactDetails.vue?vue&type=script&lang=js&"
export * from "./DialogContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports